(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-default"]) return;
  try {
    
// Use Shopify's native localization endpoint and preserve the current page/anchor.
document.addEventListener('change', function (event) {
  if (!event.target.matches('select[data-db-language]')) return;
  const form = event.target.form;
  if (!form) return;
  const returnTo = form.elements.namedItem('return_to');
  if (returnTo) returnTo.value = window.location.pathname + window.location.search + window.location.hash;
  form.requestSubmit();
});
// Keep the authored hall and consultation anchors below the complete sticky header.
// Capture these links before the legacy theme's smooth-scroll handler runs.
function daoBloomAnchor(url) {
  if (!url.hash || url.origin !== window.location.origin || url.pathname !== window.location.pathname) return null;
  let id;
  try { id = decodeURIComponent(url.hash.slice(1)); } catch { return null; }
  if (id !== 'private-consultation' && id !== 'pantheon-top' && !id.startsWith('hall-')) return null;
  return document.getElementById(id);
}
function daoBloomReveal(target) {
  const header = document.getElementById('shopify-section-header-default');
  target.style.scrollMarginTop = ((header ? header.getBoundingClientRect().height : 0) + 20) + 'px';
  const align = function () {
    const top = window.scrollY + target.getBoundingClientRect().top - (header ? header.getBoundingClientRect().height : 0) - 20;
    window.scrollTo({ top: Math.max(0, top), behavior: 'instant' });
  };
  align();
  // The inherited sticky-header handler changes document flow on the first scroll.
  requestAnimationFrame(function () { requestAnimationFrame(align); });
}
document.addEventListener('click', function (event) {
  if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const link = event.target.closest('a[href]');
  if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
  if (link.closest('.db-mobile-menu')) link.closest('details').open = false;
  const url = new URL(link.href, window.location.href);
  const target = daoBloomAnchor(url);
  if (!target) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  window.history.pushState(null, '', url.href);
  daoBloomReveal(target);
}, true);
window.addEventListener('pageshow', function () {
  const target = daoBloomAnchor(new URL(window.location.href));
  if (target) requestAnimationFrame(function () { daoBloomReveal(target); });
});

  } catch(e) { console.error(e); }
})();
})();
